import axios from 'axios'
import { ResponseCRUD, ResponseObject, ResponseObjectPaginated } from '../model'
import {
  ConfigFacturationColumnModel,
  ConfigFacturationModelDTO,
} from '../model/configFacturation.model'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL
export function getFactConfig(dto: ConfigFacturationModelDTO, page: number) {
  return axios.post<ResponseObjectPaginated<ConfigFacturationColumnModel[]>>(
    `${BASEURL}/configurationIntervalStay/getAllConfigurationIntervalStay/${page}`,
    dto,
  )
}

export function getFactConfigById(dto: any | undefined) {
  return axios.get<ResponseObject<ConfigFacturationColumnModel>>(
    `${BASEURL}/configurationIntervalStay/getConfigurationIntervalStayById?id=${dto}`,
  )
}

export function createFactConfig(dto: ConfigFacturationModelDTO) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/configurationIntervalStay/createConfigurationIntervalStay`,
    dto,
  )
}

export function deleteFactConfig(dto: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/configurationIntervalStay/deleteConfigurationIntervalStay?id=${dto}`,
  )
}

export function updateFactConfig(dto: ConfigFacturationModelDTO) {
  return axios.put<ResponseCRUD>(
    `${BASEURL}/configurationIntervalStay/updateConfigurationIntervalStay`,
    dto,
  )
}

export function getFactConfigByValueId(idSite: string, idCliente: string, idApplication: string, vista: string) {
  return axios.get<ResponseObject<ConfigFacturationColumnModel>>(
    `${BASEURL}/configurationIntervalStay/getConfigurationIntervalStayValueById?idCliente=${idCliente}&idSite=${idSite}&idAplicacion=${idApplication}&idVistaPermiso=${vista}`,
  )
}
